import { NgxLoggerLevel } from 'ngx-logger';
import { Environment } from './env.model';

export const environment: Environment = {
  production: false,
  apiURL: 'https://dev.geteazi.de',
  logLevel: NgxLoggerLevel.DEBUG,
  paymentWidgetUrl: 'https://test.vr-pay-ecommerce.de',
};
